module.exports = __webpack_public_path__ + "img/People Manager.d6c72bd7.svg";